import { api } from './api';

export interface SesionCaja {
  id: number;
  cajaId: number;
  usuarioId: number;
  fechaApertura: string;
  fechaCierre?: string;
  montoApertura: number;
  montoCierre?: number;
  montoEfectivoEsperado?: number;
  montoEfectivoReal?: number;
  diferencia?: number;
  totalVentas: number;
  totalEfectivo: number;
  totalTarjeta: number;
  totalOtros: number;
  estado: 'abierta' | 'cerrada' | 'cancelada';
  notas?: string;
  caja?: {
    id: number;
    name: string;
    numeroCaja: number;
  };
  usuario?: {
    id: number;
    name: string;
    email: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface SesionCajaCreate {
  cajaId: number;
  montoApertura?: number;
  notas?: string;
}

export interface SesionCajaCierre {
  montoCierre?: number;
  montoEfectivoReal?: number;
  notas?: string;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const sesionCajaService = {
  getAll: async (
    page = 1,
    limit = 20,
    cajaId?: number,
    estado?: string,
    fechaDesde?: string,
    fechaHasta?: string
  ): Promise<PaginatedResponse<SesionCaja>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (cajaId) params.append('cajaId', cajaId.toString());
    if (estado) params.append('estado', estado);
    if (fechaDesde) params.append('fechaDesde', fechaDesde);
    if (fechaHasta) params.append('fechaHasta', fechaHasta);
    
    const response = await api.get<PaginatedResponse<SesionCaja>>(`/sesiones-caja?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { sesion: SesionCaja } }> => {
    const response = await api.get<{ data: { sesion: SesionCaja } }>(`/sesiones-caja/${id}`);
    return response.data;
  },

  getActiva: async (cajaId: number): Promise<{ data: { sesion: SesionCaja | null } }> => {
    const response = await api.get<{ data: { sesion: SesionCaja | null } }>(`/sesiones-caja/activa?cajaId=${cajaId}`);
    return response.data;
  },

  abrir: async (data: SesionCajaCreate): Promise<{ data: { sesion: SesionCaja } }> => {
    const response = await api.post<{ data: { sesion: SesionCaja } }>('/sesiones-caja', data);
    return response.data;
  },

  cerrar: async (id: number, data: SesionCajaCierre): Promise<{ data: { sesion: SesionCaja } }> => {
    const response = await api.post<{ data: { sesion: SesionCaja } }>(`/sesiones-caja/${id}/cerrar`, data);
    return response.data;
  }
};

